export default __webpack_public_path__ + "static/youjoh2-265810dc36cd6fcee8d260137d5ae635.jpg";